// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Promotions from 'Containers/Promotions/Promotions';

const StyledPromotionsPage = styled.div``;

const PromotionsPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let promotionsPageClassName = bodyAttributes?.class || '';
  if (!promotionsPageClassName.includes('PromotionsPage')) {
    promotionsPageClassName += 'PromotionsPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.promotions') }</title>
        <body className={ promotionsPageClassName } />
      </Helmet>
      <StyledPromotionsPage theme={ theme } className="grid-container">
        <Promotions />
      </StyledPromotionsPage>
    </>
  );
});
PromotionsPage.displayName = 'PromotionsPage';

export default PromotionsPage;
